export var generateConversationName = function generateConversationName() {
  var date = new Date();
  var formattedDate = date.toLocaleDateString(undefined, {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit'
  });
  var formattedTime = date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
  var name = "".concat(formattedDate, " ").concat(formattedTime);
  return name;
};